import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Wrench, Clock } from "lucide-react";
import { api, apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import StatusBadge from "@/components/StatusBadge";

export default function BookService() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [types, setTypes] = useState([]);
  const [mine, setMine] = useState([]);
  const [f, setF] = useState({ service_type: "", description: "", phone: "", address: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (user === false) nav("/login?next=/services"); }, [user, nav]);
  useEffect(() => { api.get("/service-types").then((r) => setTypes(r.data)).catch(() => {}); }, []);
  const loadMine = () => api.get("/service-requests/mine").then((r) => setMine(r.data)).catch(() => {});
  useEffect(() => { if (user) loadMine(); }, [user]);

  const submit = async (e) => {
    e.preventDefault();
    if (!f.service_type) return toast.error("Service type chunein");
    setBusy(true);
    try { await api.post("/service-requests", f); toast.success("Service request bhej di gayi!"); setF({ service_type: "", description: "", phone: "", address: "" }); loadMine(); }
    catch (er) { toast.error(apiErr(er)); } finally { setBusy(false); }
  };

  if (!user) return null;

  return (
    <div className="max-w-lg mx-auto px-4 py-8" data-testid="book-service-page">
      <div className="text-center mb-6">
        <div className="w-14 h-14 bg-orange-500 rounded-2xl flex items-center justify-center text-white mx-auto"><Wrench size={26} /></div>
        <h1 className="text-2xl font-bold mt-3">Book a Service</h1>
        <p className="text-slate-500 text-sm">AC, fridge, TV, inverter, CCTV — installation & repair. Hamari team aapse sampark karegi.</p>
      </div>

      <form onSubmit={submit} className="bg-white rounded-2xl border border-slate-100 p-6 space-y-3">
        <select data-testid="bs-type" value={f.service_type} onChange={(e) => setF({ ...f, service_type: e.target.value })} className="w-full border border-slate-200 rounded-xl px-4 py-3 text-sm">
          <option value="">Service type chunein…</option>
          {types.map((t) => <option key={t.id} value={t.name}>{t.name}</option>)}
        </select>
        <textarea data-testid="bs-desc" placeholder="Problem batayein (optional)" value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} className="w-full border border-slate-200 rounded-xl px-4 py-3 text-sm h-20" />
        <input data-testid="bs-phone" placeholder="Contact phone" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} className="w-full border border-slate-200 rounded-xl px-4 py-3 text-sm" />
        <input data-testid="bs-address" placeholder="Service address" value={f.address} onChange={(e) => setF({ ...f, address: e.target.value })} className="w-full border border-slate-200 rounded-xl px-4 py-3 text-sm" />
        <button data-testid="bs-submit" disabled={busy} className="w-full py-3 bg-orange-500 hover:bg-orange-600 disabled:opacity-60 text-white rounded-xl font-bold transition-colors">{busy ? "Bhej rahe hain…" : "Request Service"}</button>
      </form>

      <div className="mt-6">
        <h2 className="text-sm font-bold uppercase tracking-wide text-slate-500 mb-2">My Requests</h2>
        {mine.length === 0 ? (
          <div className="text-center py-8 text-slate-400" data-testid="no-service-requests"><Clock size={26} className="mx-auto opacity-30 mb-1" />Abhi koi service request nahi.</div>
        ) : (
          <div className="space-y-2">
            {mine.map((s) => (
              <div key={s.id} data-testid={`my-service-${s.id}`} className="bg-white rounded-xl border border-slate-100 p-3 flex items-center justify-between">
                <div><p className="font-semibold text-sm">{s.service_type}</p><p className="text-xs text-slate-400">{s.request_no} · {new Date(s.created_at).toLocaleDateString("en-IN")}{s.technician_name ? ` · ${s.technician_name}` : ""}</p></div>
                <StatusBadge status={s.status} testid={`my-service-status-${s.id}`} />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
